import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[elRef]',
  exportAs: 'elRef',
  standalone: false,
})
export class ElRefDirective {
  constructor(public elRef: ElementRef) {}
}
